import BaseQuery from "@/stateManagement/BaseQuery";
import { singleton } from "tsyringe";

import type { CustomerActiveRewardsState } from "../stores/RewardsCustomerActiveRewardsStore";
import RewardsCustomerActiveRewardsStore from "../stores/RewardsCustomerActiveRewardsStore";

@singleton()
class RewardsCustomerActiveRewardsQuery extends BaseQuery<CustomerActiveRewardsState> {
    constructor(protected store: RewardsCustomerActiveRewardsStore) {
        super(store);
    }

    customerActiveRewardsList$ = this.select(
        (state) => state.customerActiveRewardsList
    );

    lastActiveReward$ = this.select(
        (state) => state.customerActiveRewardsList[0] ?? null
    );

    status$ = this.select((state) => state.status);
}

export default RewardsCustomerActiveRewardsQuery;
